export default __webpack_public_path__ + "static/Inter-upright-48781b347e30390dbe66cf7d0fd9b3c1.woff2";